import React from 'react';
import { FAQAccordion } from '../../components/FAQAccordion';
const faqs = [{
  question: 'What ages do you teach?',
  answer: 'Storm teaches Mini Troopers for ages 3–5 and Kids Taekwondo (Storm Troopers) for ages 6+. We also offer Family Classes if a parent wants to train alongside their child.'
}, {
  question: 'Does my child need any experience to start?',
  answer: 'No. The vast majority of new Storm kids start with zero martial arts experience. Beginner classes are built specifically to teach the fundamentals from day one.'
}, {
  question: 'I searched for "kids karate" — is Storm a karate school?',
  answer: 'No, Storm teaches Taekwondo (Olympic-style, WT / Kukkiwon aligned). Many parents use "karate" as a catch-all term when searching for martial arts. The confidence, discipline, focus and respect benefits are the same — and Storm is happy to help you decide if Taekwondo is the right fit for your child.'
}, {
  question: 'Do you honor previous belt rankings?',
  answer: "Storm honors previous Taekwondo belt rankings when appropriate. Talk to a Storm coach about your child's background so we can place them in the right class."
}, {
  question: 'What should my child wear to the trial class?',
  answer: 'Comfortable athletic clothing is perfect for the trial — t-shirt, sweatpants or leggings, bare feet on the mat. No uniform purchase required to start.'
}, {
  question: 'Where is Storm located and which areas do you serve?',
  answer: 'Storm Taekwondo is at 24786 Crestview, Farmington Hills, MI 48335. We serve families from Farmington Hills, Commerce, Walled Lake, Wixom, Novi, Northville, Livonia, Waterford and other Southeast Michigan communities.'
}];
export function KidsFAQQuestions() {
  return <FAQAccordion faqs={faqs} data-id="element-1913" />;
}